import { css, SerializedStyles } from '@emotion/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme: ICustomTheme;
};

export const cssProductTitle = (theme: ICustomTheme): SerializedStyles =>
  css({
    [theme.breakpoints.down('sm')]: {
      color: theme.colors.paletteFromBO.main,
      fontSize: theme.typography.h5.fontSize,
    },
  });

export const cssProductTitleDeclaration = (
  theme: ICustomTheme,
): SerializedStyles =>
  css({
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      color: theme.colors.paletteFromBO.main,
      fontSize: theme.typography.h5.fontSize,
    },
  });

export const cssPanel = (theme: ICustomTheme): SerializedStyles =>
  css({
    boxShadow: 'none',
    margin: '0 !important',
    '::before': {
      backgroundColor: theme.palette.grey[100],
      opacity: '1 !important',
    },
  });
